'use client';

import { Suspense, use } from 'react';

import { SocialReferralPage } from '@flipster/features/src/social-referral-page';
import { ReferralCampaignContext } from '@flipster/features/src/social-referral-page/bunja';

import { Footer } from '@web/app/_layout/footer';

interface Props {
  params: Promise<{ campaignName: string }>;
}

const Page = ({ params }: Props) => {
  const { campaignName } = use(params);
  return (
    <ReferralCampaignContext value={campaignName}>
      <Suspense>
        <SocialReferralPage />
      </Suspense>
      <Footer css={{ display: { tabletDown: 'none' } }} />
    </ReferralCampaignContext>
  );
};

export default Page;
